const contentElements = document.querySelectorAll(
  "accordion-tab .accordion__content"
);

contentElements.forEach((contentElement) => {
  const delimiterIndex = contentElement.innerHTML.indexOf("<!-- split -->");
  if (delimiterIndex !== -1) {
    // Extract content before and after the delimiter
    const contentBeforeDelimiter = contentElement.innerHTML.substring(
      0,
      delimiterIndex
    );
    const contentAfterDelimiter =
      contentElement.innerHTML.substring(delimiterIndex);

    // Initially, show content before delimiter and hide content after delimiter
    contentElement.innerHTML = contentBeforeDelimiter;

    // Add "Show More" button to toggle visibility of content after delimiter
    const showMoreBtn = document.createElement("button");
    showMoreBtn.textContent = "Show More";
    showMoreBtn.classList.add("show-more-btn");
    showMoreBtn.addEventListener("click", function () {
      const buttonPosition =
        showMoreBtn.getBoundingClientRect().top + window.scrollY;
      if (contentElement.classList.contains("expanded")) {

        contentElement.innerHTML = contentBeforeDelimiter;
        this.textContent = "Show More";

        // Scroll back to the position of the "Show More" button
        const topPosition =
          showMoreBtn.getBoundingClientRect().top + window.scrollY - 150;
        window.scrollTo({ top: topPosition, behavior: "smooth" });
      } else {

        contentElement.innerHTML =
          contentBeforeDelimiter + contentAfterDelimiter;
        this.textContent = "Show Less";
      }
      contentElement.classList.toggle("expanded");
    });

    contentElement.parentNode.appendChild(showMoreBtn);
  }
});


const SF_URL = `https://${Shopify.shop}/api/2026-07/graphql.json`;
const SF_TOKEN = '17da049a922488d51185f6301247b22b';

console.log('SF_URL', SF_URL);

async function sf(query, variables) {
  const res = await fetch(SF_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': SF_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });

  return (await res.json()).data;
}

const GET_CODES = `
  query($id: ID!) {
    cart(id: $id) {
      discountCodes {
        code
        applicable
      }
    }
  }
`;

const SET_CODES = `
  mutation($id: ID!, $codes: [String!]!) {
    cartDiscountCodesUpdate(
      cartId: $id,
      discountCodes: $codes
    ) {
      cart {
        discountCodes {
          code
          applicable
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`;

let _cartIdCache = null;
async function getCartId(bust = false) {
  if (_cartIdCache && !bust) return _cartIdCache;
  const cart = await (await fetch('/cart.js')).json();
  _cartIdCache = `gid://shopify/Cart/${cart.token}`;
  return _cartIdCache;
}

async function refreshDrawer() {
  // The drawer element is <mini-cart id="mini-cart"> rendered from the
  // "mini-cart" section (there is no #CartDrawer / cart-drawer section).
  const html = await (
    await fetch(`${theme.routes.cart_url}?section_id=mini-cart&t=${Date.now()}`)
  ).text();

  const fresh = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector('.shopify-section');

  const currentDrawer = document.getElementById('mini-cart');

  if (fresh && currentDrawer) {
    currentDrawer.innerHTML = fresh.innerHTML;
  }

  // Keep cart icon bubble counts in sync
  document.dispatchEvent(new CustomEvent('cart:refresh'));

  await renderApplied();
  await syncCouponBox();
}


/**
 * Set the coupon message area. Plain text by default; pass isHtml: true
 * when the message may contain markup (e.g. a link from a richtext field).
 */
function setCouponMsg(msg, text, { isHtml = false, isError = false } = {}) {
  if (!msg) return;
  msg.style.color = isError ? 'red' : '';
  if (isHtml) {
    msg.innerHTML = text;
  } else {
    msg.textContent = text;
  }
}

/* Clears the red error highlight from every coupon card */
function clearCouponCardErrors() {
  document.querySelectorAll('.coupon-card.coupon-card--error')
    .forEach(card => card.classList.remove('coupon-card--error'));
}

/**
 * Apply discount code
 */
async function applyDiscountCode(container, errorCard = null) {
  if (!container) return;

  const input = container.querySelector('input[name="code"]');
  const button = container.querySelector('.cart-coupon__apply');

  // msg may be a sibling of container (modal layout) or inside it (original layout)
  const msg = container.querySelector('.cart-coupon__msg')
    || container.parentElement?.querySelector('.cart-coupon__msg');

  if (!input || !button) return;

  const newCode = input.value.trim();
  const errorTemplate = errorCard?.querySelector('template[data-coupon-error]');
  const customErrorHtml = errorTemplate?.innerHTML || '';

  if (!newCode) return;

  // A fresh attempt supersedes any previous card's error highlight
  clearCouponCardErrors();

  button.disabled = true;
  button.classList.add('coupon-apply-active');
  const originalButtonHTML = button.innerHTML;
  button.innerHTML = '<span class="coupon-apply-spinner" aria-hidden="true"></span>';
  setCouponMsg(msg, 'Checking...');

  try {
    const id = await getCartId();

    // Get existing discount codes
    const existingData = await sf(GET_CODES, { id });

    const existing = (
      existingData?.cart?.discountCodes || []
    ).map(c => c.code);

    // Mutation replaces all codes,
    // so keep existing codes + new code
    const codes = [...new Set([...existing, newCode])];

    const result = await sf(SET_CODES, {
      id,
      codes
    });

    const r = result?.cartDiscountCodesUpdate;

    if (!r) {
      setCouponMsg(msg, 'Something went wrong.', { isError: true });
      return;
    }

    if (r.userErrors.length) {
      if (customErrorHtml) {
        setCouponMsg(msg, customErrorHtml, {
          isHtml: true,
          isError: true
        });
      } else {
        setCouponMsg(msg, r.userErrors[0].message, {
          isError: true
        });
      }

      if (errorCard) {
        errorCard.classList.add('coupon-card--error');
      }

      return;
    }


    const appliedCode = r.cart.discountCodes.find(
      c => c.code.toLowerCase() === newCode.toLowerCase()
    );

    if (!appliedCode || !appliedCode.applicable) {
      await sf(SET_CODES, {
        id,
        codes: existing
      });

      if (customErrorHtml) {
        setCouponMsg(msg, customErrorHtml, {
          isHtml: true,
          isError: true
        });
      } else {
        setCouponMsg(
          msg,
          `"${newCode}" isn't valid for this cart.`,
          { isError: true }
        );
      }

      if (errorCard) {
        errorCard.classList.add('coupon-card--error');
      }

      return;
    }


    input.value = '';
    setCouponMsg(msg, '');

    // Close coupon modal and show success modal
    const couponModal = document.getElementById('couponModal');
    if (couponModal) couponModal.classList.remove('active');

    const successModal = document.getElementById('couponSuccessModal');
    const successCode = document.getElementById('couponSuccessCode');
    if (successCode) successCode.textContent = appliedCode.code;
    if (successModal) successModal.style.display = 'flex';

    await refreshDrawer();
    await syncCouponBox();

  } catch (error) {
    console.error('Discount code error:', error);
    setCouponMsg(msg, 'Something went wrong. Please try again.', { isError: true });
  } finally {
    button.disabled = false;
    button.classList.remove('coupon-apply-active');
    button.innerHTML = originalButtonHTML;
  }
}

function closeCouponSuccess() {
  const successModal = document.getElementById('couponSuccessModal');
  if (successModal) successModal.style.display = 'none';
} 


/**
 * Apply button click
 *
 * Event delegation is used because
 * cart drawer HTML can be replaced dynamically.
 */
document.addEventListener('click', async (e) => {

  const button = e.target.closest('.cart-coupon__apply');

  if (!button) return;
  const container = button.closest('#CartCouponForm');

  if (!container) return;

  await applyDiscountCode(container);
});

/**
 * Clear any coupon card error highlight once the shopper edits the code by hand
 */
document.addEventListener('input', (e) => {
  const input = e.target.closest('#CartCouponForm input[name="code"]');
  if (input) clearCouponCardErrors();
});

 /**
 * Press Enter inside discount input
 */
document.addEventListener('keydown', async (e) => {

  if (e.key !== 'Enter') return;

  const input = e.target.closest(
    '#CartCouponForm input[name="code"]'
  );

  if (!input) return;

  e.preventDefault();

  const container = input.closest('#CartCouponForm');

  if (!container) return;

  await applyDiscountCode(container);
});


/**
 * Render applied discount codes
 */
async function renderApplied() {

  const container = document.querySelector('#CartCouponForm');

  if (!container) return;

  const list = container.querySelector(
    '.cart-coupon__applied'
  );

  if (!list) return;

  try {

    const id = await getCartId();

    const data = await sf(GET_CODES, { id });

    const codes = (
      data?.cart?.discountCodes || []
    ).filter(c => c.applicable);

    list.innerHTML = codes.map(c => `
      <li class="cart-coupon__item">
        <span>${c.code}</span>

        <button
          type="button"
          class="cart-coupon__remove"
          data-code="${c.code}"
          aria-label="Remove code ${c.code}"
        >
          ×
        </button>
      </li>
    `).join('');

  } catch (error) {
    console.error('Render applied codes error:', error);
  }
}


/**
 * Remove discount code
 */
document.addEventListener('click', async (e) => {

  const btn = e.target.closest('.cart-coupon__remove');

  if (!btn) return;

  btn.disabled = true;

  const removeCode = btn.dataset.code.toLowerCase();

  try {

    const id = await getCartId();

    const data = await sf(GET_CODES, { id });

    const keep = (
      data?.cart?.discountCodes || []
    )
      .map(c => c.code)
      .filter(c => c.toLowerCase() !== removeCode);

    const result = await sf(SET_CODES, {
      id,
      codes: keep
    });

    const r = result?.cartDiscountCodesUpdate;

    if (r?.userErrors?.length) {

      btn.disabled = false;

      const msg = document.querySelector(
        '#CartCouponForm .cart-coupon__msg'
      );

      if (msg) {
        msg.textContent = r.userErrors[0].message;
      }

      return;
    }

    await refreshDrawer();

  } catch (error) {

    console.error('Remove discount code error:', error);

    btn.disabled = false;
  }
});


/**
 * Initial render
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { renderApplied(); syncCouponBox(); });
} else {
  renderApplied();
  syncCouponBox();
}

/**
 * Sync #coupon-box-box between "Apply Coupon" and "Applied" states.
 * Uses the Storefront API which is the authoritative source for
 * discounts applied via cartDiscountCodesUpdate mutation.
 */
async function syncCouponBox() {
  const box = document.getElementById('coupon-box-box');
  if (!box) return;

  try {
    const id = await getCartId();
    const data = await sf(GET_CODES, { id });
    console.log('[syncCouponBox] cartId:', id, 'discountCodes:', data?.cart?.discountCodes);
    const codes = (data?.cart?.discountCodes || [])
      .filter(c => c.applicable)
      .map(c => c.code);

    const codeEl = document.getElementById('coupon-box-applied-code');

    if (codes.length) {
      box.classList.add('coupon-applied');
      if (codeEl) codeEl.textContent = codes.join(', ');
    } else {
      box.classList.remove('coupon-applied');
      if (codeEl) codeEl.textContent = '';
    }
  } catch (e) {
    console.error('syncCouponBox error:', e);
  }
}

/* Remove button inside #coupon-box-box */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#coupon-box-remove-btn');
  if (!btn) return;

  e.stopPropagation();
  btn.disabled = true;
  btn.textContent = 'Removing...';

  try {
    const id = await getCartId();
    await sf(SET_CODES, { id, codes: [] });
    await refreshDrawer();
    await syncCouponBox();
  } catch (err) {
    console.error('Remove coupon (box) error:', err);
  } finally {
    btn.disabled = false;
    btn.textContent = 'Remove';
  }
});



// ***************************start quick-cart-discount modal*******************

document.addEventListener('click', async function (event) {

  const modal = document.getElementById('couponModal');

  /* OPEN MODAL — only when no coupon is applied */
  const couponButton = event.target.closest('#coupon-box-box');

  if (couponButton) {
    event.preventDefault();

    // If a coupon is already applied, the box is non-interactive (remove btn handled separately)
    if (couponButton.classList.contains('coupon-applied')) return;

    if (modal) {
      modal.classList.add('active');
    }

    return;
  }


  /* CLOSE MODAL */
  const closeButton = event.target.closest('#couponModalClose');

  if (closeButton) {
    event.preventDefault();

    if (modal) {
      modal.classList.remove('active');
    }

    // Reset the form so a stale code/error isn't shown next time the modal opens
    const container = document.getElementById('CartCouponForm');
    if (container) {
      const input = container.querySelector('input[name="code"]');
      if (input) input.value = '';

      const msg = container.querySelector('.cart-coupon__msg')
        || container.parentElement?.querySelector('.cart-coupon__msg');
      setCouponMsg(msg, '');

      const applyBtn = container.querySelector('.coupon-input-apply');
      if (applyBtn) applyBtn.classList.remove('coupon-apply-active');
    }
    clearCouponCardErrors();

    return;
  }

  /* COUPON CARD APPLY BUTTON — fills input and triggers apply */
  const cardButton = event.target.closest('.coupon-card-button');

  if (cardButton) {
    event.preventDefault();

    const code = cardButton.dataset.code;
    if (!code) return;

    const container = document.getElementById('CartCouponForm');
    if (!container) return;

    const input = container.querySelector('input[name="code"]');
    if (input) input.value = code;

    const card = cardButton.closest('.coupon-card');

    await applyDiscountCode(container, card);

    return;
  }

});

/* Highlight APPLY button when input has text */
document.addEventListener('input', function (e) {
  const input = e.target.closest('#CartCouponForm input[name="code"]');
  if (!input) return;

  const container = input.closest('#CartCouponForm');
  if (!container) return;

  const btn = container.querySelector('.coupon-input-apply');
  if (!btn) return;

  if (input.value.trim()) {
    btn.classList.add('coupon-apply-active');
  } else {
    btn.classList.remove('coupon-apply-active');
  }
});
// ***************************end quick-cart-discount modal*******************